export const addData = {
  // 状态-数据选择框
  auditOptions: [
    { label: '全部', value: '' },
    { label: '未审核', value: 'AUDIT_NON' },
    { label: '初审驳回', value: 'AUDIT_NO_PASS' },
    { label: '复审驳回', value: 'RE_AUDIT_NO_PASS' },
    { label: '待初审', value: 'AUDIT_ING' },
    { label: '待复审', value: 'RE_AUDIT_ING' },
    { label: '复审通过', value: 'RE_AUDIT_PASS' }
  ],
  publishState: [
    { label: '全部' },
    { label: '未发布', value: '-1' },
    { label: '审核中', value: 'AUDIT_ING' },
    { label: '已通过', value: 'AUDIT_PASS' },
    { label: '未通过', value: 'AUDIT_NO_PASS' }
  ]
}
